import { SCOPES } from "constants/constants";
import { useNavigate } from "react-router-dom";
import { useUserContext } from "api/user/UserProvider";

const FALLBACK_AVATAR = "/static/img/login_avatar.56ac71a.gif";

const WelcomeBack = () => {
  const navigate = useNavigate();
  const { setUserScope } = useUserContext();
  const rawPictureUrl = localStorage.getItem("picture_url");
  const pictureUrl =
    rawPictureUrl && rawPictureUrl !== "undefined" && rawPictureUrl !== "null"
      ? rawPictureUrl
      : null;

  return (
    <div>
      <div
        className={`login-avatar  ${
          localStorage.getItem("id") ? "cursor " : ""
        }`}
      >
        <img
          src={
            pictureUrl
              ? `${process.env.REACT_APP_APP_BACK_URL}/${pictureUrl}`
              : FALLBACK_AVATAR
          }
          alt="Welcome"
          className="avatar-img"
          onError={(e) => {
            if (e.currentTarget.src !== window.location.origin + FALLBACK_AVATAR) {
              e.currentTarget.src = FALLBACK_AVATAR;
            }
          }}
          onClick={() => {
            if (localStorage.getItem("id")) {
              navigate("/perso/dashboard");
              setUserScope(SCOPES.PERSO);
            }
          }}
        ></img>
      </div>
      <p className="welcome">Bienvenue</p>
      <p className="welcome-back">
        Knock knock knock, Penny ? Ah non. Qui êtes-vous ?
      </p>
    </div>
  );
};

export default WelcomeBack;
